<template lang="pug">
  v-card.py-3.px-4(flat @click="openDetails")
    v-row(no-gutters)
      v-col.shrink(style="margin-top: 2px;")
        y-checkbox.ma-0.pa-0.mr-2(v-model="lead.selected" @click.once="")
      v-col
        v-row(no-gutters)
          v-col
            div.p2.textColorHint--text
              v-icon.mr-1(v-if="lead.custom_label && lead.custom_label.properties" :color="lead.custom_label.properties.color" small style="margin-bottom: 2px;") mdi-label
              | {{ `#${lead.rid}` }} - {{ lead.record_date | convertServerDate }}
            div.s1.mb-1.basic800--text {{ lead.name }}
          v-col.shrink
            v-chip.text-uppercase.my-auto.button-AA-tiny(small outlined label :color="lead.status | leadStatusColor" :style="{ 'background-color': chipBackgroundColor(lead.status) + '!important' }" ) {{ lead.status | leadStatusDisplay }}
        v-row.c1.basic600--text(no-gutters align="center")
          v-col
            p.mb-0 {{ totalQuantity }} {{ totalQuantity > 1 ? 'items' : 'item' }}
          v-col
            template(v-if="isFetchingInv")
              v-progress-circular.ml-3(:width="2" :size="10" color="primary400" indeterminate)
            template(v-else)
              p.mb-0 {{ totalPrice | displayPrice }}
          v-col
            div.d-flex.align-center.justify-end(v-if="lead.abandoned_checkout")
              eva-icon.mr-1(name="shopping-cart-outline" :fill="$vuetify.theme.themes[$theme].danger500" width="15" style="margin-top: -6px; margin-bottom: -8px")
              div.danger500--text.c1 {{ $t('abandoned') }}
        template(v-if="showDetails")
          div.d-flex
            div.mt-1(style="word-break: break-word")
              p.c1.mb-1.primary400--text {{ $t('from') }} {{ lead.form.name }}
              p.c1.mb-1.primary400--text {{ $t('sent_to') }} {{ lead.member.user.first_name }} {{ lead.member.user.last_name }}
            v-spacer
            div(v-if="historyCount > 1 && Auth('component', '/admin/database#view_history_button')")
              v-btn.label.px-0(color="transparent" text @click.stop="openViewHistory = true" small)
                eva-icon.mt-1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].primary400" width="14")
                div.primary400--text {{ $t('view_history') }}
          div.c1.mb-2.primary400--text(v-if="lead.referrer") {{ lead.referrer }}

          template(v-if="lead.products.length > 0")
            v-divider.basic300.my-1
            div.py-1
              template(v-for="product in lead.products")
                v-row.mt-1(no-gutters)
                  v-col(cols="9")
                    //- PARENT NAME
                    div.p2.primary500--text {{ getName(product) }}
                    //- VARIANT NAME
                    template(v-if="product.product.variant_for && checkParentVariantName(product)")
                      div.c1.primary400--text {{ product.product.name }}
                    //- BUNDLE LIST
                    template(v-if="product.bundles.length > 0")
                      div(v-for="(bundle, bundleIndex) in product.bundles" :key="'bundle-' + bundleIndex")
                        div.c1.primary400--text {{ bundleIndex + 1 }}. {{ bundle.name }}
                        //- BUNDLE PRODUCT NOTES
                        div(v-if="bundle.product_notes_data && bundle.product_notes_data.length > 0")
                          div(v-for="note in bundle.product_notes_data" :key="note.id")
                            div.c1.primary400--text.ml-2 - 
                              strong {{ note.name }}: 
                              | {{ note.data }}
                    //- ADDON LIST
                    template(v-if="product.addons.length > 0") 
                      div(v-for="(addon, idx) in product.addons" :key="'addon-' + idx")
                        div.c1.primary400--text + {{ addon.name }}{{ addon.quantity_per_set > 1 ? ' x ' + addon.quantity_per_set : '' }}
                    //- PRODUCT NOTES
                    div.mt-1(v-if="product.product_notes_data && product.product_notes_data.length > 0")
                      div(v-for="note in product.product_notes_data" :key="note.id")
                        div.c1.primary400--text
                          strong {{ note.name }}: 
                          | {{ note.data }}

                  v-col.pl-2(cols="3")
                    p.p2.mb-0.primary500--text x {{ product.quantity }}

          template(v-if="lead.email || (lead.extra_fields_data && lead.extra_fields_data.length != 0)")
            v-divider.basic300.my-1
            div.py-1
              p.c1.mb-1.primary500--text(v-if="lead.email") {{ $t('email') }}: {{ lead.email }}
              div.c1.mb-1.primary500--text(v-for="field in lead.extra_fields_data" style="word-break: break-word;") {{ field.name }}: {{ field.value }}

    .detailsSheet
      y-bottom-sheet(v-model='detailsSheet' inset scrollable max-width="600px" )
        v-card.py-4(flat)
          div.pa-0
            div.px-3
              v-row(no-gutters align="center")
                v-col.pr-3
                  p.h6.mb-0.basic1000--text {{ lead.name }}
                v-col.shrink
                  template(v-if="updating_status")
                    div(style="width: 35px")
                      v-progress-circular(indeterminate color="primary" size="20" width="2")
                  template(v-else)
                    v-menu(left offset-y)
                      template(v-slot:activator="{ on, attrs }")
                        v-chip.text-uppercase.my-auto.button-AA-tiny(small outlined label :color="lead.status | leadStatusColor" :style="{ 'background-color': chipBackgroundColor(lead.status) + '!important' }" v-on="on") {{ lead.status | leadStatusDisplay }}
                      v-list(dense)
                        template(v-if="lead.paid")
                          v-list-item(v-for="p in paidStatusSelections" :key="p.id" @click="updateStatus(p.id)")
                            v-list-item-title.s2.basic800--text {{ p.name }}
                        template(v-else)
                          v-list-item(v-for="p in statusSelections" :key="p.id" @click="updateStatus(p.id)")
                            v-list-item-title.s2.basic800--text {{ p.name }}

              div.p2.basic600--text.mt-1(v-if="lead.custom_label && lead.custom_label.properties")
                v-icon.mr-1(:color="lead.custom_label.properties.color" small) mdi-label
                | {{ lead.custom_label.properties.text }}

              v-row(no-gutters align="center")
                v-col
                  p.s2.my-1.primary400--text {{ `#${lead.rid}` }} - {{ lead.record_date | convertServerDate }}
                v-col.shrink(v-if="historyCount > 1 && Auth('component', '/admin/database#view_history')")
                  v-btn.label.px-0(color="transparent" text @click="openViewHistory = true" small)
                    eva-icon.mt-1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].primary400" width="14")
                    div.primary400--text {{ $t('view_history') }}
            v-divider.basic300.my-1
          v-card-text.pa-0
            div.px-3.py-3
              v-row(no-gutters)
                v-col(cols="8")
                  p.c1.mb-1.primary400--text {{ $t('from') }} {{ lead.form.name }}
                  p.c1.mb-1.primary400--text {{ $t('sent_to') }} {{ lead.member.user.first_name }} {{ lead.member.user.last_name }}
                v-col(cols="4")
                  p.c1.mb-1.primary400--text {{ totalQuantity }} {{ totalQuantity > 1 ? $t('items') : $t('item') }}
                  p.c1.mb-1.primary400--text {{ totalPrice | displayPrice }}
              div.c1.mb-1.primary400--text(v-if="lead.referrer") {{ lead.referrer }}
            template(v-if="lead.products.length > 0")
              v-divider.basic300.my-1
              div.px-3.py-3
                template(v-for="product in lead.products")
                  v-row.mt-1(no-gutters)
                    v-col(cols="8")
                      //- PARENT NAME
                      div.p2.primary500--text {{ getName(product) }}
                      //- VARIANT NAME
                      template(v-if="product.product.variant_for && checkParentVariantName(product)")
                        div.c1.primary400--text {{ product.product.name }}
                      //- BUNDLE LIST
                      template(v-if="product.bundles.length > 0")
                        div(v-for="(bundle, bundleIndex) in product.bundles" :key="'bundle-' + bundleIndex")
                          div.c1.primary400--text {{ bundleIndex + 1 }}. {{ bundle.name }}
                          //- BUNDLE PRODUCT NOTES
                          div(v-if="bundle.product_notes_data && bundle.product_notes_data.length > 0")
                            div(v-for="note in bundle.product_notes_data" :key="note.id")
                              div.c1.primary400--text.ml-2 - 
                                strong {{ note.name }}: 
                                | {{ note.data }}
                      //- ADDON LIST
                      template(v-if="product.addons.length > 0") 
                        div(v-for="(addon, idx) in product.addons" :key="'addon-' + idx")
                          div.c1.primary400--text + {{ addon.name }}{{ addon.quantity_per_set > 1 ? ' x ' + addon.quantity_per_set : '' }}
                      //- PRODUCT NOTES
                      div.mt-1(v-if="product.product_notes_data && product.product_notes_data.length > 0")
                        div(v-for="note in product.product_notes_data" :key="note.id")
                          div.c1.primary400--text
                            strong {{ note.name }}: 
                            | {{ note.data }}
                    v-col(cols="4")
                      p.c1.mb-1.primary500--text x {{ product.quantity }}

            template(v-if="lead.email || (lead.shipping_address && !lead.pickup) || (lead.extra_fields_data && lead.extra_fields_data.length != 0)")
              v-divider.basic300.my-1
              div.px-3.py-3
                p.c1.mb-1.primary500--text(v-if="lead.email") {{ $t('email') }}: {{ lead.email }}
                v-row(no-gutters)
                  v-col.pr-1(v-if="lead.shipping_address && !lead.pickup" :cols="lead.extra_fields_data && lead.extra_fields_data.length > 0 ? 6 : 12")
                    .ship-to-others.mb-2(v-if="lead.shipping_address.phone && !lead.phone.endsWith(lead.shipping_address.phone)")
                      div.c1.primary500--text.font-weight-bold {{ $t('ship_to') }}:
                      div.c1.primary500--text(v-if="lead.shipping_address.name") {{ lead.shipping_address.name }}
                      div.c1.primary500--text(v-if="lead.shipping_address.phone") {{ lead.shipping_address.phone | phoneFormat }}
                    .ship-to-self(v-else)
                      div.c1.primary500--text.font-weight-bold {{ $t('shipping_address') }}:
                    div.c1.primary500--text {{ lead.shipping_address.address_1 }},
                    div.c1.primary500--text(v-if="lead.shipping_address.address_2") {{ lead.shipping_address.address_2 }},
                    template(v-if="lead.shipping_address.area")
                      div.c1.primary500--text {{ lead.shipping_address.postcode }} {{ lead.shipping_address.area }},
                      div.c1.primary500--text {{ lead.shipping_address.suburb }}, {{ lead.shipping_address.city }},
                    div.c1.primary500--text(v-else) {{ lead.shipping_address.postcode }} {{ lead.shipping_address.city }},
                    div.c1.primary500--text.mb-1 {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.
                  v-col(:cols="lead.shipping_address ? 6 : 12" :class="lead.shipping_address ? 'pl-1' : ''")
                    div.c1.primary500--text.mb-1(v-for="field in lead.extra_fields_data" style="word-break: break-word;") {{ field.name }}: {{ field.value }}
          div.pt-3.pb-1
            v-row(no-gutters)
              v-col.px-1(align="center")
                v-card(flat @click="clickOpenWa")
                  v-layout.pb-1(style="width: 40px; height: 40px;")
                    BrandWhatsappIcon.ma-auto(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].primary500 }")
                  .c1.primary500-text WhatsApp
              v-col.px-1(align="center" v-if="lead.paid")
                v-card(flat @click="openViewInvoice")
                  v-layout(style="width: 40px; height: 40px;")
                    eva-icon.ma-auto(name="file-text-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary500")
                  .c1.primary500-text {{ $t('view_receipt') }}
              v-col.px-1(align="center" v-else-if="totalQuantity")
                v-card(flat @click="openViewInvoice")
                  v-layout(style="width: 40px; height: 40px;")
                    eva-icon.ma-auto(name="file-text-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary500")
                  .c1.primary500-text {{ $t('view_invoice') }}
              v-col.px-1(align="center")
                v-menu(left top :offset-y='true')
                  template(v-slot:activator="{ on, attrs }")
                    v-card(flat v-on="on")
                      v-layout(style="width: 40px; height: 40px;")
                        eva-icon.ma-auto(name="share-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary500")
                      .c1.primary500-text {{ $t('share_invoice') }}
                  v-list
                    v-list-item(@click="shareUrlToWA")
                      v-list-item-title.s2.basic800--text {{ $t('share_to_whatsapp') }}
                    v-list-item(@click="copyUrl" v-clipboard:copy="getShareLinkURL()")
                      v-list-item-title.s2.basic800--text {{ $t('copy_url') }}
              v-col.px-1(align="center")
                v-menu(left top :offset-y='true')
                  template(v-slot:activator="{ on, attrs }")
                    v-card(flat v-on="on")
                      v-layout(style="width: 40px; height: 40px;")
                        eva-icon.ma-auto(name="more-vertical-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary500")
                      .c1.primary500-text {{ $t('more') }}
                  v-list(dense)
                    v-list-item(@click="openEditCustomerDialog = !openEditCustomerDialog")
                      v-list-item-title.s2.basic800--text {{ $t('edit_customer_info') }}
                    template(v-if="lead.paid")
                      template(v-if="lead.form.type !== 'store'")
                        v-list-item(@click="openRepeatOrderDialog = !openRepeatOrderDialog")
                          v-list-item-title.s2.basic800--text {{ $t('repeat_this_order') }}
                    template(v-else-if="lead.status !== 'partial_payment'")
                      v-list-item(@click="openEditOrderDialog = !openEditOrderDialog")
                        v-list-item-title.s2.basic800--text {{ $t('edit_order') }}
                    //- v-menu(:open-on-hover="true" left offset-x)
                      template(v-slot:activator="{ on, attrs }")
                        v-list-item(v-on="on")
                          v-list-item-title.s2.basic800--text Update status
                      v-list(dense)
                        v-list-item
                          v-list-item-title.s2.basic800--text test
                    v-list-item(@click="openCustomLabelDialog = !openCustomLabelDialog")
                      v-list-item-title.s2.basic800--text {{ $t('label') }}
                    v-list-item(@click="openDeleteDialog = true")
                      v-list-item-title.s2.basic800--text {{ $t('delete') }}
    .modals
      edit-customer-info(v-if="openEditCustomerDialog" :open.sync="openEditCustomerDialog" :parentLead.sync="lead")
      edit-order(v-if="openEditOrderDialog" :open.sync="openEditOrderDialog" :parentLead.sync="lead" )
      custom-label(v-if="openCustomLabelDialog" :open.sync="openCustomLabelDialog" :parentLead.sync="lead" )
      product-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :parentLead.sync="lead" :company="company")
      repeat-order(v-if="openRepeatOrderDialog" :open.sync="openRepeatOrderDialog" :lead.sync="lead")
      view-order-history(v-if="openViewHistory" :open.sync="openViewHistory" :lead.sync="lead")
        //- v-list
          v-subheader Share invoice by
          v-list-item(@click="shareUrlToWA")
            v-list-item-avatar
              v-icon(color="green") fab fa-whatsapp
            v-list-item-title WhatsApp
          v-list-item(@click="copyUrl" v-clipboard:copy="getShareLinkURL()")
            v-list-item-avatar
              v-icon mdi-content-copy
            v-list-item-title Copy url
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_item') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('delete_item_description') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import EditCustomerInfo from '@/components/dialogs/database/EditCustomerInfo.vue'
import EditOrder from '@/components/dialogs/database/EditOrder.vue'
import CustomLabel from '@/components/dialogs/database/CustomLabel.vue'
import ProductInvoice from '@/components/dialogs/database/ProductInvoice.vue'
import ViewOrderHistory from '@/components/dialogs/database/ViewOrderHistory.vue'
import RepeatOrder from '@/components/dialogs/database/RepeatOrder.vue'

export default {
  name: 'DatabaseItem',
  props: ['parentLead', 'index', 'showDetails', 'selectAll','company'],
  components: { EditCustomerInfo, EditOrder, CustomLabel, ProductInvoice, ViewOrderHistory, RepeatOrder },
  data: () => ({
    isFetchingInv: false,
    isLoading: false,
    openEditCustomerDialog: false,
    openEditOrderDialog: false,
    openInvoiceDialog: false,
    openRepeatOrderDialog: false,
    openShowCustomerDetails: false,
    openCustomLabelDialog: false,
    openShowDetails: true,
    openDeleteDialog: false,
    openViewHistory: false,
    detailsSheet: false,
    latestCompany: null,
    historyCount: 0,
    updating_status: false,
    invoice: null,
    statusSelections: [
      { name: 'New', id: 'new' },
      { name: 'Follow up', id: 'follow_up' },
      { name: 'Partial payment', id: 'partial_payment' },
      { name: 'Reject', id: 'reject' }
    ],
    paidStatusSelections: [
      { name: 'Processed', id: 'processed' },
      { name: 'Shipped', id: 'shipped' },
      { name: 'Received', id: 'received' },
      { name: 'Cancelled', id: 'cancelled' }
    ],
  }),
  computed: {
    ...mapState('user', ['member']),
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    totalQuantity () {
      if (!this.lead.products) return 0
      return this.lead.products.reduce((sum, p) => {
        return sum + p.quantity
      }, 0)
    },
    totalPrice () {
      if (this.invoice) {
        return this.invoice.total_amount
      }
      if (!this.lead.products) return 0
      return this.lead.products.reduce((sum, p) => {
        return sum + (p.price_per_set * p.quantity)
      }, 0)
    }
  },
  watch: {
    selectAll (val) {
      this.$set(this.lead, 'selected', val)
    }
  },
  mounted () {
    this.fetchLeadCount()
    this.fetchInvoice()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchLeadCount() {
      this.$axios.get('/leads/', { params: { form__company: this.lead.company, page: 1, page_size: 1, phone: this.lead.phone }})
      .then(resp => {
        this.historyCount = resp.data.count
      })
    },
    fetchInvoice () {
      this.isFetchingInv = true
      this.$axios.get(`/invoices/${this.lead.pid}/`)
        .then((response) => {
          this.invoice = response.data
        })
        .finally(() => {
          this.isFetchingInv = false
        })
    },
    getName (product) {
      if (product.product.variant_for) {
        if (this.checkParentVariantName(product)) {
          return product.name.replace(`(${product.product.name})`, '')
        }
      }
      return product.name
    },
    checkParentVariantName(product) {
      return product.name.includes(`(${product.product.name})`)
    },
    openViewInvoice() {
      this.openInvoiceDialog = true
    },
    openDetails() {
      this.detailsSheet = true
    },
    getShareLinkURL () {
      if (this.$subdomain) {
        return `${this.$subdomain}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/invoices/${this.lead.pid}`
      } else {
        return `http://localhost:8080/invoices/${this.lead.pid}`
      }
    },
    clickOpenWa () {
      window.open(`https://api.whatsapp.com/send?phone=${this.lead.phone}`)
    },
    shareUrlToWA() {

      window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}&phone=${this.lead.phone}`)
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
    },
    startDelete() {
      this.isLoading = true
      this.axios.patch(`/leads/${this.lead.pid}/`, { status: 'deleted' })
        .then(() => {
          this.$emit('deleted', this.lead)
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    chipBackgroundColor (status) {
      if (status === 'new') {
        return this.$vuetify.theme.themes[this.$theme].infoT08
      } else if (status === 'follow_up') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'partial_payment') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'reject') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'processed') {
        return this.$vuetify.theme.themes[this.$theme].successT08
      } else if (status === 'shipped') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'received') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'cancelled') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'error') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === '') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      }
      return this.$vuetify.theme.themes[this.$theme].basic600T08
    },
    updateStatus (stat) {
      this.updating_status = true
      let data = { status: stat }
      this.axios.patch(`/leads/${this.lead.pid}/`, data)
        .then(resp => {
          this.lead = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.updating_status = false
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "delete_item_description": "Are you sure you want to delete this item? This item will be deleted permanently."
  },
  "id": {
    "delete_item_description": "Anda yakin ingin menghapus item ini? Item ini akan dihapus secara permanen."
  }
}
</i18n>